import { render, staticRenderFns } from "./IlpaAbout.vue?vue&type=template&id=2881b2a8"
import script from "./IlpaAbout.vue?vue&type=script&lang=js"
export * from "./IlpaAbout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports